import React from 'react';
import SpoilerInfo from '../common/SpoilerInfo.jsx';

const FavoritesInfo = (props) => {
  return <SpoilerInfo>
      <p>
        { gettext('Добавляйте аранжировки и каверы в свой список пожеланий, чтобы не потерять то, что вам интересно.')
        + ' ' + gettext('Если вдруг цена на товар изменится, вы обязательно получите уведомление об этом.') }
      </p>
  </SpoilerInfo>;
};

export default FavoritesInfo;